export const INFO_CREATE_RESET = 'INFO_CREATE_RESET';
export const INFO_CREATE_SET_CREATED = 'INFO_CREATE_SET_CREATED';
export const INFO_CREATE_SET_ERROR = 'INFO_CREATE_SET_ERROR';
export const INFO_CREATE_SET_VIOLATIONS = 'INFO_CREATE_SET_VIOLATIONS';
export const INFO_CREATE_TOGGLE_LOADING = 'INFO_CREATE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/info/create/mutation_types.js